import { useEffect, useRef, useState } from "react";

import api from "../../services/api";
import { useAuth } from "../../hooks/auth";
import Loading from "../../components/Loading";
import Sidebar from "../../components/Sidebar";
import DTClassif from "../../components/ComponentsClassif/DTClassifs";
import ModalClassif from "../../components/ComponentsClassif/ModalClassif";
import { ClassifDTO } from "../../dtos/ClassifDTO";

import { ButtonAddItemContent, Container, Content, Header } from "./styles";
import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Button, Text, useDisclosure, VStack } from "@chakra-ui/react";
import { useToast } from "../../hooks/toast";
import { AppError } from "../../utils/AppError";

const Classificacao: React.FC = () => {
	const { permissions } = useAuth();
	const { addToast } = useToast();

	const [loading, setLoading] = useState(true);
	const [loadingDT, setLoadingDT] = useState(true);

	const[classifs, setClassifs] = useState<ClassifDTO[]>([]);

	const [classifModal, setClassifModal] = useState<ClassifDTO>({} as ClassifDTO);
	const [modalClassifVisible, setModalClassifVisible] = useState(false);

	const { isOpen, onOpen: onOpenAlertDelete, onClose } = useDisclosure();
	const cancelRef = useRef(null);

	async function fetchClassifs() {
		try {
			setLoadingDT(true);
			const { data } = await api.get('/portal/classif/index');

			setClassifs(data);
		}
		catch (error) {
			const isAppError = error instanceof AppError;
			const msg = isAppError ? error.message : 'Não foi possível buscar as classificações.';

			addToast({
				type: 'error',
				title: 'Buscar Classificações!',
				description: msg,
			});
		}
		finally {
			setLoadingDT(false);
			setLoading(false);
		}
	}

	useEffect(() => {
		fetchClassifs();
	}, []);

	async function handleDeleteClassif(classif: ClassifDTO) {
		try {
			setLoadingDT(true);
			setLoading(true);

			const { data } = await api.delete(`/portal/classif/${classif.id_classif}`);

			if (data.che === 'S') {
				addToast({
					type: 'success',
					title: 'Conta Deletada!',
					description: data.msg,
				});
			} else {
				addToast({
					type: 'error',
					title: 'Deletar Conta!',
					description: data.msg,
				});
			}
		}
		catch (error) {
			const isAppError = error instanceof AppError;
			const msg = isAppError ? error.message : 'Não foi possível deletar a conta.';

			addToast({
				type: 'error',
				title: 'Deletar Conta!',
				description: msg,
			});
		}
		finally {
			onClose();
			fetchClassifs();
		}
	};

	return (
		<>
			{modalClassifVisible && (
				<ModalClassif
					isVisible={modalClassifVisible}
					onClose={() => setModalClassifVisible(false)}
					classif={classifModal}
					fetchClassifs={fetchClassifs}
				/>
			)}

			<Container>
				<Sidebar />

				{loading && <Loading />}

				<Content>
					<Header>
						<div className='header-texts'>
							<h1>Classificações.</h1>
							<h2>Cadastre ou altere suas classificações.</h2>
						</div>

						{permissions.incluir && (
							<ButtonAddItemContent
								onClick={() => {
									setClassifModal({} as ClassifDTO);
									setModalClassifVisible(true);
								}}
							>
								+ Novo
							</ButtonAddItemContent>
						)}
					</Header>

					{classifs.length > 0 && (
						!loadingDT &&
						<DTClassif
							data={classifs}
							setClassifModal={setClassifModal}
							setModalClassifVisible={setModalClassifVisible}
							onOpenAlertDelete={onOpenAlertDelete}
						/>
					)}
				</Content>
			</Container>

			<AlertDialog
				isOpen={isOpen}
				leastDestructiveRef={cancelRef}
				onClose={onClose}
				isCentered
			>
				<AlertDialogOverlay>
					<AlertDialogContent>
						<AlertDialogHeader fontSize='lg' fontWeight='bold'>
							Delete Classificação
						</AlertDialogHeader>

						<AlertDialogBody>
							<Text>Tem certeza que deseja excluir esta classificação?</Text>

							<VStack
								p={2}
								mt={2}
								spacing={1}
								alignItems="flex-start"
								borderWidth={1}
								borderColor="gray.100"
								rounded={8}
							>
								<Text fontWeight={500}>{classifModal.nome}</Text>
								<Text>Código: {classifModal.id_classif}</Text>
							</VStack>
						</AlertDialogBody>

						<AlertDialogFooter>
							<Button ref={cancelRef} onClick={onClose}>
								Cancel
							</Button>

							<Button
								colorScheme='red'
								ml={3}
								onClick={() => handleDeleteClassif(classifModal)}
							>
								Delete
							</Button>
						</AlertDialogFooter>
					</AlertDialogContent>
				</AlertDialogOverlay>
			</AlertDialog>
		</>
	)
}

export default Classificacao;